import { Theme } from '@mui/material';
import { getTypographyVariants } from '@theme/styleOverrides';

export const yellowTextButtonStyles = (theme: Theme) => ({
  fontSize: getTypographyVariants(theme.palette.fontSize).body.fontSize,
  margin: 0,
  padding: 0,
  ml: '4px',
  mr: '4px',
  verticalAlign: 'text-top',
});
